export const percents = function(percentage: number, value: number) {
  return value * (percentage / 100)
}
